import React from "react"

function Podium({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.33699 14.8644V11.8589"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.115 17.8678V14.8623"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2017 14.8644V11.8589"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9791 17.8678V14.8623"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8438 17.8678V14.8623"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9629 11.2325V8.22705"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1631 16.793H7.71417V27.7728H28.2858V19.9003H23.4393"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5013 23.911V12.7168H21.5549V23.911"
        stroke="#003E4C"
        strokeWidth="1.0052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Podium
